<!--
  Read-only. Three questions in order: what a credit is, what it buys, and how
  buying works — which is the order someone comparing this sensor against a
  per-sqkm one actually asks them in.
-->
<div class="vci">
  <div class="vci__head">
    <!-- Unnamed on purpose. `sensorName` falls back to the neutral "This
         sensor", which reads fine mid-sentence in the lede below but not in a
         heading ("How This sensor credits work"). The dialog is opened from one
         specific row, so the title has no naming to do. -->
    <h4 class="vci__title">How credits work</h4>
    <button class="vci__x" type="button" aria-label="Close" (click)="onClose()">
      <mat-icon class="material-icons-outlined">close</mat-icon>
    </button>
  </div>

  <!-- The scroller is the full width of the dialog; the reading cap lives on the
       wrapper inside it. Capping the scroller itself parked the bar against the
       cards, floating short of the dialog edge with background either side. -->
  <div class="vci__body" id="scrollcustom">
    <div class="vci__body-inner">
      <p class="vci__lede">
        {{ sensorName }} is priced in credits rather than by area or scene. You buy credits when you
        task the sensor, then spend them on the actions below — one at a time, as you need them,
        any time while your time of interest (TOI) is open.
      </p>

      <section class="vci__card">
        <h5 class="vci__card-title">What a credit buys</h5>

        <!-- The rate, as the equation it actually is, at the head of the list it
             prices. It used to be a pill trailing the lede's last sentence,
             where it read as an aside to a paragraph about TOIs rather than as
             the one number that converts every row below into money. -->
        <div class="vci__rate" *ngIf="showPricing">
          <span class="vci__rate-eq">
            <b>1 credit</b>
            <i>=</i>
            <b class="vci__rate-price">{{ costLabel(unitPrice) }}</b>
          </span>
          <span class="vci__rate-note">Each action below costs a fixed number of credits.</span>
        </div>

        <!-- No `credits` bound: this is the price list, not an answer to an
             amount. The purchase dialog binds one and the same rows grow a
             "buys N" column.

             `showTargets` marks a row with the shape that reaches it. This list
             is unfiltered, so a row the reader's own task cannot spend on is
             still shown, and the tag is what says so on the row itself — a
             footnote underneath had to describe it from a distance.
             `hasTargetVariants` asks whether ANY entry carries a target, so
             the column appears whenever there is something to mark. On the
             shipped catalogue that is one row: `refresh`, the area-only sweep,
             which a point task cannot reach. It used to ask for one 'aoi' AND
             one 'poi' entry, which stopped being answerable when `nearby`
             dropped its target — see the getter for why that took the whole
             column down with it. -->
        <app-voyage-credit-catalogue
          [actions]="actions"
          [unitPrice]="unitPrice"
          [showPricing]="showPricing"
          [showTargets]="hasTargetVariants"
        ></app-voyage-credit-catalogue>
      </section>

      <section class="vci__card">
        <h5 class="vci__card-title">Buying and spending</h5>

        <ul class="vci__facts">
          <li>
            <mat-icon class="material-icons-outlined">shopping_cart</mat-icon>
            <span>
              Credits are bought per task, as part of tasking this sensor. {{ boundsLabel }}
            </span>
          </li>
          <li>
            <mat-icon class="material-icons-outlined">travel_explore</mat-icon>
            <!-- "this sensor's panel" rather than the panel's own name: the map
                 panel is titled after the operator, so naming it here would be a
                 second way to leak what the heading no longer says. -->
            <span>
              They are spent from this sensor's panel on the collection map, an action at a time.
              Nothing is charged until you take one.
            </span>
          </li>
          <li>
            <mat-icon class="material-icons-outlined">schedule</mat-icon>
            <span>Credits stay spendable for as long as the task's TOI is open.</span>
          </li>
          <li>
            <mat-icon class="material-icons-outlined">undo</mat-icon>
            <span>Unused credits can be refunded on request, subject to approval.</span>
          </li>
        </ul>
      </section>
    </div>
  </div>
</div>
